import React, { useState } from "react";
import styled from "@emotion/styled";
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getPhoneNumbers } from "./selector";
import { selectPhoneNumber } from "./action";

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const AbsoluteContainer = styled.div`
  position: absolute;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1px;
  color: rgba(31, 32, 33, 0.5);
  height: 100%;
  width: 100%;
  top: 14px;
  right: -20px;
  pointer-events: none;
`;

const PhoneNumberPicker = () => {
  const dispatch = useDispatch();
  const phoneNumbers = useSelector(state =>
    getPhoneNumbers({
      phoneNumbers: state.orderVerification.phoneNumbers
    })
  );
  const selectedPhoneNumberId = useSelector(
    state => state.orderVerification.selectedPhoneNumberId
  );

  const [phoneValue, changePhoneValue] = useState(
    selectedPhoneNumberId
      ? phoneNumbers.find(item => item.id === selectedPhoneNumberId)
      : null
  );
  return (
    <Select
      value={phoneValue}
      classNamePrefix="react-select-3"
      placeholder={"Phone number"}
      options={phoneNumbers}
      blurInputOnSelect={true}
      onChange={e => {
        dispatch(selectPhoneNumber(e.id));
        changePhoneValue(e);
      }}
      components={{
        Input: props => {
          return (
            <InputContainer>
              <components.Input {...props} />
            </InputContainer>
          );
        },
        ValueContainer: props => {
          return (
            <>
              {props.selectProps.value && (
                <AbsoluteContainer>PHONE NUMBER</AbsoluteContainer>
              )}
              <components.ValueContainer
                {...props}
                className={`custom-value-container-${
                  props.selectProps.value ? "selected" : ""
                }`}
              />
            </>
          );
        }
      }}
    />
  );
};

export default PhoneNumberPicker;
